export default function Section17() {
    const reasons = [
      {
        title: "End-to-End Project Management ",
        text: "From planning to launch, we manage every step of the project, ensuring organization, quality, and timely delivery.",
      },
      {
        title: " User-Focused Design",
        text: "Our designs are intuitive and easy to navigate, improving engagement and driving conversions while enhancing brand perception.",
      },
      {
        title: "Continuous Optimization & Support ",
        text: "Ongoing updates and technical support keep websites secure, fast, and functional, allowing businesses to focus on growth.",
      },
      {
        title: "Speed & Mobile Performance ",
        text: "We build fast, responsive websites optimized for all devices, ensuring smooth performance, quick loading, and excellent user experience.",
      },
      
    ];
  
    return (
      <div className="Section17 py-[1px] md:py-[10px] bg-[white]">
        {/* Section Heading */}
        <div className="text-center w-[90%] md:w-[65%] mx-auto mb-[40px]">
          <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[36px] md:leading-[46px] mb-2">
           Why Businesses Chose<span className="text-[#DA2128]">Mean3</span>
          </h2>
          <p className="text-[#555] text-[16px] md:text-[18px] font-medium mb-3">
           Proven Expertise We deliver reliable solutions backed by experience, creating high-performing websites that meet business goals.
           </p>
         
        </div>
  
        {/* Cards Grid */}
        <div className="flex justify-center flex-wrap gap-[25px] w-[85%] mx-auto">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className={`${index % 2 === 0
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
                } w-[90%] sm:w-[46%] xl:w-[30%] p-[4%] md:p-[2%] rounded-2xl shadow-md text-left`}
            >
              <h3 className="text-[20px] md:text-[22px] font-bold mb-3 leading-[28px]">
                {reason.title}
              </h3>
              <p className="text-[13px] md:text-[14px] mb-4">{reason.text}</p>
            </div>
          ))}
        </div>
  
        {/* CTA */}
        <div className="text-center mt-12">
          
        </div>
  
        {/* Divider Line */}
        <div className="line mb-[55px] mt-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
      </div>
    );
  }
  